// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ids-tabs-container {
  --tab-width: 100%;
  --vertical-container-width: 250px;
  --more-tab-space-right: 45px;
  --more-tab-space-rtl-left: 45px;
  --ids-swappable-item-padding-block: 0;
  --ids-swappable-item-height: var(--ids-tab-height);
  --ids-swappable-item-icon-margin-inline: -4px -15px;
  display: flex;
  position: relative;
}
.ids-tabs-container.is-scrolled-left::before, .ids-tabs-container.is-scrolled-right::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  background-image: var(--ids-tab-overflow-effect-left);
  height: 100%;
  width: 40px;
  pointer-events: none;
  z-index: 1;
}
.ids-tabs-container.is-scrolled-left.rtl::before, .ids-tabs-container.is-scrolled-right.rtl::after {
  background-image: var(--ids-tab-overflow-effect-right);
  inset-inline-start: unset;
  inset-inline-end: 0;
}
.ids-tabs-container.is-scrolled-right::after {
  background-image: var(--ids-tab-overflow-effect-right);
  inset-inline-start: unset;
  inset-inline-end: 0;
}
.ids-tabs-container.hide-headers {
  display: none;
}
.ids-tabs-container.is-scrolled-right.rtl::after {
  background-image: var(--ids-tab-overflow-effect-left);
}
.ids-tabs-container.is-scrolled-left.rtl::before {
  background-image: var(--ids-tab-overflow-effect-right);
  inset-inline-start: 0;
  inset-inline-end: unset;
}
.ids-tabs-container.has-more-actions.is-scrolled-right::after {
  background-image: var(--ids-tab-overflow-effect-right);
  inset-inline-end: 42px;
  inset-inline-start: unset;
  top: 0;
}
.ids-tabs-container.has-more-actions.is-scrolled-right.rtl::after {
  background-image: var(--ids-tab-overflow-effect-left);
}
.ids-tabs-container.color-variant-module.is-scrolled-left::before {
  top: 0;
  left: 0;
  height: var(--ids-tab-module-height);
}
.ids-tabs-container.has-app-menu.color-variant-module.is-scrolled-left::before {
  left: var(--ids-tab-more-button-width);
}
.ids-tabs-container.color-variant-module.has-more-actions.is-scrolled-right::after {
  right: var(--more-tab-space-right);
  left: unset;
  top: 0;
  height: var(--ids-tab-module-height);
}
.ids-tabs-container.color-variant-module.has-more-actions.rtl.is-scrolled-left::before {
  inset-inline-end: 0;
}
.ids-tabs-container.color-variant-module.rtl.is-scrolled-left::before {
  height: var(--ids-tab-module-height);
  inset-inline-end: 44px;
}
.ids-tabs-container.color-variant-module.has-more-actions.rtl.is-scrolled-right::after {
  left: var(--more-tab-space-rtl-left);
  right: unset;
  top: 0;
}
.ids-tabs-container.color-variant-header.is-scrolled-right::after {
  right: 94px;
  top: 0;
}
.ids-tabs-container.color-variant-header.is-scrolled-left::before {
  top: 0;
}
.ids-tabs-container.color-variant-header.rtl.is-scrolled-right::after {
  left: 94px;
  right: unset;
  top: 0;
}
.ids-tabs-container.color-variant-header.rtl.is-scrolled-left::before {
  top: 0;
}
.ids-tabs-container:not(.orientation-vertical) {
  height: var(--ids-tab-height);
}
.ids-tabs-container:not(.orientation-vertical) .ids-tabs-list {
  width: var(--tab-width);
}
.ids-tabs-container.orientation-vertical {
  background-color: var(--ids-tab-vertical-color-background-default);
  border-inline-end: 1px solid var(--ids-tab-vertical-color-border-default);
  flex-direction: column;
  height: 100%;
  width: var(--vertical-container-width);
}
.ids-tabs-container.orientation-vertical .ids-tabs-list,
.ids-tabs-container.orientation-vertical .ids-tabs-list-more {
  flex-direction: column;
}
.ids-tabs-container.orientation-vertical ids-icon {
  margin-inline-end: 8px;
}
.ids-tabs-container.color-variant-header {
  height: var(--ids-tab-header-height);
  max-height: var(--ids-tab-header-height);
  min-height: var(--ids-tab-header-height);
}

.ids-tabs-list {
  flex-shrink: 1;
  overflow: auto;
  position: relative;
  scroll-behavior: smooth;
  display: flex;
  padding-inline-start: 0;
  margin-block-start: 0;
  margin-block-end: -1px;
  margin-inline-start: 0;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.ids-tabs-list::-webkit-scrollbar {
  display: none;
}

.ids-tabs-list-more {
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  padding-inline-start: 0;
  margin-block-start: 0;
  margin-inline-start: 0;
}

.ids-tabs-container:not(.orientation-vertical):not(.color-variant-module) {
  margin-top: var(--ids-space-xs);
}

.ids-tabs-container:not(.orientation-vertical):not([class*=color-variant-]),
.ids-tabs-container.header-bottom-border:not(.orientation-vertical) {
  border-bottom: 1px solid var(--ids-tab-divider-color-background);
  height: unset;
  margin-top: 0;
}

.ids-tabs-container.color-variant-module {
  border-bottom: 1px solid var(--ids-tab-module-tab-color-border-bottom);
  height: var(--ids-tab-module-height);
}`, "",{"version":3,"sources":["webpack://./src/components/ids-tabs/ids-tabs.scss"],"names":[],"mappings":"AAEA;EACE,iBAAA;EACA,iCAAA;EACA,4BAAA;EACA,+BAAA;EACA,qCAAA;EACA,kDAAA;EACA,mDAAA;EAEA,aAAA;EACA,kBAAA;AAFF;AAIE;EAEE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,qDAAA;EACA,YAAA;EACA,WAAA;EACA,oBAAA;EACA,UAAA;AAHJ;AAME;EAEE,sDAAA;EACA,yBAAA;EACA,mBAAA;AALJ;AAQE;EACE,sDAAA;EACA,yBAAA;EACA,mBAAA;AANJ;AASE;EACE,aAAA;AAPJ;AAUE;EACE,qDAAA;AARJ;AAWE;EACE,sDAAA;EACA,qBAAA;EACA,uBAAA;AATJ;AAYE;EACE,sDAAA;EACA,sBAAA;EACA,yBAAA;EACA,MAAA;AAVJ;AAaE;EACE,qDAAA;AAXJ;AAeE;EACE,MAAA;EACA,OAAA;EACA,oCAAA;AAbJ;AAgBE;EACE,sCAAA;AAdJ;AAiBE;EACE,kCAAA;EACA,WAAA;EACA,MAAA;EACA,oCAAA;AAfJ;AAkBE;EACE,mBAAA;AAhBJ;AAmBE;EACE,oCAAA;EACA,sBAAA;AAjBJ;AAoBE;EACE,oCAAA;EACA,YAAA;EACA,MAAA;AAlBJ;AAsBE;EACE,WAAA;EACA,MAAA;AApBJ;AAuBE;EACE,MAAA;AArBJ;AAwBE;EACE,UAAA;EACA,YAAA;EACA,MAAA;AAtBJ;AAyBE;EACE,MAAA;AAvBJ;AA2BE;EACE,6BAAA;AAzBJ;AA2BI;EACE,uBAAA;AAzBN;AA8BE;EACE,kEAAA;EACA,yEAAA;EACA,sBAAA;EACA,YAAA;EACA,sCAAA;AA5BJ;AA+BI;;EAEE,sBAAA;AA7BN;AAgCI;EACE,sBAAA;AA9BN;AAmCE;EACE,oCAAA;EACA,wCAAA;EACA,wCAAA;AAjCJ;;AAqCA;EACE,cAAA;EACA,cAAA;EACA,kBAAA;EACA,uBAAA;EACA,aAAA;EACA,uBAAA;EACA,qBAAA;EACA,sBAAA;EACA,sBAAA;EACA,wBAAA;EACA,qBAAA;AAlCF;;AAqCA;EACE,aAAA;AAlCF;;AAqCA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;EACA,sBAAA;AAlCF;;AAsCA;EACE,+BAAA;AAnCF;;AAsCA;;EAEE,gEAAA;EACA,aAAA;EACA,aAAA;AAnCF;;AAuCA;EACE,sEAAA;EACA,oCAAA;AApCF","sourcesContent":["@use '../../themes/mixins/ids-core-mixins' as *;\n\n.ids-tabs-container {\n  --tab-width: 100%;\n  --vertical-container-width: 250px;\n  --more-tab-space-right: 45px;\n  --more-tab-space-rtl-left: 45px;\n  --ids-swappable-item-padding-block: 0;\n  --ids-swappable-item-height: var(--ids-tab-height);\n  --ids-swappable-item-icon-margin-inline: -4px -15px;\n\n  display: flex;\n  position: relative;\n\n  &.is-scrolled-left::before,\n  &.is-scrolled-right::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    background-image: var(--ids-tab-overflow-effect-left);\n    height: 100%;\n    width: 40px;\n    pointer-events: none;\n    z-index: 1;\n  }\n\n  &.is-scrolled-left.rtl::before,\n  &.is-scrolled-right.rtl::after {\n    background-image: var(--ids-tab-overflow-effect-right);\n    inset-inline-start: unset;\n    inset-inline-end: 0;\n  }\n\n  &.is-scrolled-right::after {\n    background-image: var(--ids-tab-overflow-effect-right);\n    inset-inline-start: unset;\n    inset-inline-end: 0;\n  }\n\n  &.hide-headers {\n    display: none;\n  }\n\n  &.is-scrolled-right.rtl::after {\n    background-image: var(--ids-tab-overflow-effect-left);\n  }\n\n  &.is-scrolled-left.rtl::before {\n    background-image: var(--ids-tab-overflow-effect-right);\n    inset-inline-start: 0;\n    inset-inline-end: unset;\n  }\n\n  &.has-more-actions.is-scrolled-right::after {\n    background-image: var(--ids-tab-overflow-effect-right);\n    inset-inline-end: 42px;\n    inset-inline-start: unset;\n    top: 0;\n  }\n\n  &.has-more-actions.is-scrolled-right.rtl::after {\n    background-image: var(--ids-tab-overflow-effect-left);\n  }\n\n  // Module Tabs\n  &.color-variant-module.is-scrolled-left::before {\n    top: 0;\n    left: 0;\n    height: var(--ids-tab-module-height);\n  }\n\n  &.has-app-menu.color-variant-module.is-scrolled-left::before {\n    left: var(--ids-tab-more-button-width);\n  }\n\n  &.color-variant-module.has-more-actions.is-scrolled-right::after {\n    right: var(--more-tab-space-right);\n    left: unset;\n    top: 0;\n    height: var(--ids-tab-module-height);\n  }\n\n  &.color-variant-module.has-more-actions.rtl.is-scrolled-left::before {\n    inset-inline-end: 0;\n  }\n\n  &.color-variant-module.rtl.is-scrolled-left::before {\n    height: var(--ids-tab-module-height);\n    inset-inline-end: 44px;\n  }\n\n  &.color-variant-module.has-more-actions.rtl.is-scrolled-right::after {\n    left: var(--more-tab-space-rtl-left);\n    right: unset;\n    top: 0;\n  }\n\n  // Header Tabs\n  &.color-variant-header.is-scrolled-right::after {\n    right: 94px;\n    top: 0;\n  }\n\n  &.color-variant-header.is-scrolled-left::before {\n    top: 0;\n  }\n\n  &.color-variant-header.rtl.is-scrolled-right::after {\n    left: 94px;\n    right: unset;\n    top: 0;\n  }\n\n  &.color-variant-header.rtl.is-scrolled-left::before {\n    top: 0;\n  }\n\n  // Horizontal Tabs\n  &:not(.orientation-vertical) {\n    height: var(--ids-tab-height);\n\n    .ids-tabs-list {\n      width: var(--tab-width);\n    }\n  }\n\n  // Vertical Tabs\n  &.orientation-vertical {\n    background-color: var(--ids-tab-vertical-color-background-default);\n    border-inline-end: 1px solid var(--ids-tab-vertical-color-border-default);\n    flex-direction: column;\n    height: 100%;\n    width: var(--vertical-container-width);\n\n\n    .ids-tabs-list,\n    .ids-tabs-list-more {\n      flex-direction: column;\n    }\n\n    ids-icon {\n      margin-inline-end: 8px;\n    }\n  }\n\n  // Header Tabs\n  &.color-variant-header {\n    height: var(--ids-tab-header-height);\n    max-height: var(--ids-tab-header-height);\n    min-height: var(--ids-tab-header-height);\n  }\n}\n\n.ids-tabs-list {\n  flex-shrink: 1;\n  overflow: auto;\n  position: relative;\n  scroll-behavior: smooth;\n  display: flex;\n  padding-inline-start: 0;\n  margin-block-start: 0;\n  margin-block-end: -1px;\n  margin-inline-start: 0;\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n}\n\n.ids-tabs-list::-webkit-scrollbar {\n  display: none;\n}\n\n.ids-tabs-list-more {\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: row;\n  padding-inline-start: 0;\n  margin-block-start: 0;\n  margin-inline-start: 0;\n}\n\n// Horizontal Tabs\n.ids-tabs-container:not(.orientation-vertical):not(.color-variant-module) {\n  margin-top: var(--ids-space-xs);\n}\n\n.ids-tabs-container:not(.orientation-vertical):not([class*='color-variant-']),\n.ids-tabs-container.header-bottom-border:not(.orientation-vertical) {\n  border-bottom: 1px solid var(--ids-tab-divider-color-background);\n  height: unset;\n  margin-top: 0;\n}\n\n// Module Tabs\n.ids-tabs-container.color-variant-module {\n  border-bottom: 1px solid var(--ids-tab-module-tab-color-border-bottom);\n  height: var(--ids-tab-module-height);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
